export default __webpack_public_path__ + "static/media/product22.b36c10a2.png";